
import React from 'react';
import './footericon.css'

const Footeric = (props) => {
    return ( <>

       
                <img className='footeric' src={props.fic} alt="" />
         
     

       
            <p className='footer-btn'>{props.fbtn}</p>
         
      

    
    </> );
}
 
export default Footeric;
